import React from "react";
import { Modal } from "react-bootstrap";

const PdfPreviewModal = ({ show, handleClose, pdfUrl }) => {
    return (
        <Modal show={show} onHide={handleClose} size="lg" className="common-modal document-preview-modal" centered>
            <Modal.Header closeButton>
                <Modal.Title  className="document-preview-title">Document Preview</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="pdf-container">
                    <iframe
                        src={pdfUrl}
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        title="PDF Preview"
                    ></iframe>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default PdfPreviewModal;
